// extracted by mini-css-extract-plugin
export default {"container":"loading-spinner_container__xvVPD"};